import React from 'react';
import { RoomAudioRenderer, RoomContext } from '@livekit/components-react';
import { useAppStore, usePlayerStore, getStore } from '../../../stores/StoreContext';

/**
 * AudioConnection component for WebRTC player
 * Manages audio playback for remote participants based on viewMode
 * Only plays audio when the session is in focus mode
 * 
 * Enhanced with explicit room prop to prevent cross-talk
 * VTC context forces viewMode='focus' only on focused session, 'overview' on others
 * 
 * @param {Object} props
 * @param {Room} [props.room] - Explicit LiveKit room instance (bypasses context)
 */
const AudioConnection = ({ room: explicitRoom }) => {
    const viewMode = useAppStore((state) => state.viewMode);
    const volume = usePlayerStore((state) => state.volume);
    const muted = usePlayerStore((state) => state.muted);
    const sessionSid = useAppStore((state) => state.sessionSid);
    const AppStore = getStore('appStore');

    // Use explicit room if provided, otherwise fall back to AppStore
    const room = explicitRoom || AppStore.room;

    // Only render audio when viewMode is 'focus'
    // VTC forces viewMode based on focus state, so this is sufficient
    if (viewMode !== 'focus') {
        return null;
    }

    // Wrap in explicit RoomContext.Provider to bypass any parent context
    return (
        <RoomContext.Provider value={room}>
            <RoomAudioRenderer
                key={`audio-${sessionSid}-${muted}-${volume}`}
                muted={muted}
                excludeLocalParticipant={true}
                volume={volume / 100}
            />
        </RoomContext.Provider>
    );
};

export default AudioConnection;
